import React from 'react';
import { useFormContext } from 'react-hook-form';
import FileUpload from '../../../../../../components/FileUpload/FileUpload';
import { MdCloudUpload } from 'react-icons/md';
import HorizontalFormInput from '../../../../../../components/FormHelpers/horizontalFormInput';
import s from './Files.module.sass';
import { useTranslation } from 'react-i18next';

const Files = ({ onSubmit, previous }) => {
  const { t } = useTranslation('upload');
  const { handleSubmit, control, watch, formState: { errors } } = useFormContext();
  
  const hasPersonalDetails = watch('gdpr.hasPersonalDetails');

  const gdprRules = hasPersonalDetails ? {
    required: { value: true, message: t('files.required') }
  } : undefined;

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <h4>{t('files.header')}</h4>
      <p>{t('files.descr1')}</p>
      <FileUpload>
        <MdCloudUpload className="card-header__icon" />
        <span className="card-header__title"> {t('files.descr2')}</span>
      </FileUpload>
      {hasPersonalDetails && (
        <>
          <p>{t('files.descr3')}</p>
          <hr />
          {/* TODO: verify numbers for numbers etc */}
          <HorizontalFormInput
            name="gdpr.origin"
            control={control}
            className="form-control"
            label={t('files.gdprFields.label1')}
            placeholder={t('files.gdprFields.placeHolder1')}
            helpText={t('files.gdprFields.helpText1')}
            rules={gdprRules}
          />
          <HorizontalFormInput
            name="gdpr.purpose"
            control={control}
            className="form-control"
            label={t('files.gdprFields.label2')}
            placeholder={t('files.gdprFields.placeHolder2')}
            helpText={t('files.gdprFields.helpText2')}
            rules={gdprRules}
          />
          <HorizontalFormInput
            name="gdpr.noOfEntities"
            control={control}
            className="form-control"
            label={t('files.gdprFields.label3')}
            placeholder={t('files.gdprFields.placeHolder3')}
            helpText={t('files.gdprFields.helpText3')}
            rules={gdprRules}
          />
          <HorizontalFormInput
            name="gdpr.type"
            control={control}
            className="form-control"
            label={t('files.gdprFields.label4')}
            placeholder={t('files.gdprFields.placeHolder4')}
            helpText={t('files.gdprFields.helpText4')}
            rules={gdprRules}
          />
          <HorizontalFormInput
            name="gdpr.description"
            control={control}
            renderAs="textarea"
            className="form-control textarea--no-resize"
            rows="4"
            label={t('files.gdprFields.label5')}
            placeholder={t('files.gdprFields.placeHolder5')}
            helpText={t('files.gdprFields.helpText5')}
            rules={gdprRules}
          />
        </>
      )}
      <div className={s['files-footer']}>
        <button className="btn btn--transparent" type="button" onClick={previous}>
          {t('files.returnButton')}
        </button>
        <button type="submit" className="btn btn--primary">
          {t('files.proceedButton')}
        </button>
      </div>
    </form>
  );
};

export default Files;